export default __webpack_public_path__ + "static/media/1785.f65fcaac.png";